import { MapViewerService } from '@3ddv/ngx-dvm-internal';
import { InjectionToken } from '@angular/core';

export const MINIMAP_TOKEN = new InjectionToken<MapViewerService>(
  'MINIMAP_TOKEN'
);
